import { html } from "lit-element";

export const segments = {
	2: html`
    <svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="16.754005mm"
   height="5.3111277mm"
   viewBox="0 0 16.754005 5.3111277"
   version="1.1"
   id="svg1389"
>
  <defs
     id="defs1383" />
  <g
     id="layer1"
     transform="translate(-3.2794569e-8,-0.18887265)">
    <g
       id="g4757"
       transform="matrix(0.03647289,0,0,0.04790006,-5.8105563,-11.734394)">
      <g
         id="g4764">
        <path
           id="path3626"
           d="M 382.42206,248.91966 V 359.79901"
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.50417423;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />    
      </g>
    </g>
  </g>
</svg>
`,
	3: html`
        <svg
   width="28.338903mm"
   height="5.5984306mm"
   viewBox="0 0 28.338903 5.5984306"
   version="1.1"
   id="svg1344"
   >
  <defs
     id="defs1338" />
  <g
     id="layer1"
     transform="translate(-65.205548,-130.15912)">
    <g
       id="g5748"
       transform="matrix(0.0435782,0,0,0.01308241,60.482579,126.06517)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:23.63973618;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 576,312.9416 V 738.49812"
         id="path3749"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:23.63973618;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 328.70025,312.93543 V 740.87117"
         id="path3751"
          />    
    </g>
  </g>
</svg>

`,
	4: html`
    <svg
   width="16.718239mm"
   height="11.263509mm"
   viewBox="0 0 16.718239 11.263509"
   version="1.1"
   id="svg1502"
>
  <defs
     id="defs1496" />
  <g
     id="layer1"
     transform="translate(-58.164691,-66.850391)">
    <g
       id="g6753"
       transform="matrix(0.02778136,0,0,0.02379364,55.354486,61.942882)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:21.95401573;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="m 101.15433,441.95707 h 601.779"
         id="path3608"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:21.95401573;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 401.98197,206.25299 V 679.63618"
         id="path3616"
          />      
    </g>
  </g>
</svg>

`,
	6: html`
    <svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="27.32373mm"
   height="10.491114mm"
   viewBox="0 0 27.32373 10.491114"
   version="1.1"
   id="svg1439"
>
  <defs
     id="defs1433" />
  <g
     id="layer1"
     transform="translate(-9.77266,-20.367538)">
    <g
       id="g8750"
       transform="matrix(0.04005408,0,0,0.01992811,5.4803727,12.402326)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:19.9785862;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 107.1623,664.63974 H 789.33329"
         id="path3763"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:19.9785862;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 576.00372,402.66255 V 926.12174"
         id="path3771"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:19.9785862;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 341.2929,399.69732 V 926.14531"
         id="path3773"
          />      
    </g>
  </g>
</svg>

`,
	16: html`
    <svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="16.704176mm"
   height="16.821424mm"
   viewBox="0 0 16.704176 16.821424"
   version="1.1"
   id="svg1649"
>
  <defs
     id="defs1643" />
  <g
     id="layer1"
     transform="translate(-27.933624,-85.238097)">
    <g
       id="g9775"
       transform="matrix(0.0259058,0,0,0.02795138,22.407054,78.310264)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:20.97592545;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 213.33332,448.45638 H 858.13777"
         id="path3639"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:20.97592545;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 213.33332,649.05967 H 858.13777"
         id="path3641"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:20.97592545;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 535.66922,247.85299 V 849.66317"
         id="path3649"
          />    
    </g>
  </g>
</svg>

`,
	8: html`
   <svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="18.300346mm"
   height="22.156212mm"
   viewBox="0 0 18.300346 22.156212"
   version="1.1"
   id="svg1450"
>
  <defs
     id="defs1444" />
  <g
     id="layer1"
     transform="translate(-151.86768,-202.01118)">
    <g
       id="g12846"
       transform="matrix(0.03044293,0,0,0.03838279,147.97213,191.64165)">
      <g
         style="stroke:#e58b1f;stroke-width:2.26233077;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         transform="matrix(6.8880917,0,0,6.7975238,2639.3961,-1127.01)"
         id="g3702">
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:2.41315293;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="m -364.60513,226.78578 h 87.2718"
           id="path3686"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:2.41315293;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="m -364.60513,248.03041 h 87.2718"
           id="path3688"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:2.41315293;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="m -364.60513,269.27504 h 87.2718"
           id="path3690"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:2.41315293;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="m -320.97821,205.54116 v 84.91966"
           id="path3700"
            />
      </g>     
    </g>
  </g>
</svg>

`,

	9: html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="28.193836mm"
   height="17.101355mm"
   viewBox="0 0 28.193836 17.101355"
   version="1.1"
   id="svg1567"
>
  <defs
     id="defs1561" />
  <g
     id="layer1"
     transform="translate(-78.507248,-140.28266)">
    <g
       id="g10831"
       transform="matrix(0.04267197,0,0,0.02885162,75.711692,133.03056)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:16.08661652;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 65.512707,448.7426 H 726.22362"
         id="path3802"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:16.08661652;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 65.512707,647.66513 H 726.22362"
         id="path3804"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:16.08661652;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="m 519.60508,253.58166 v 590.5065"
         id="path3812"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:16.08661652;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 292.2779,251.3584 V 844.09303"
         id="path3814"
          />     
    </g>
  </g>
</svg>

`,

	10: html`
    <svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="16.657469mm"
   height="27.522743mm"
   viewBox="0 0 16.657469 27.522743"
   version="1.1"
   id="svg1671"
>
  <defs
     id="defs1665" />
  <g
     id="layer1"
     transform="translate(-84.275432,-135.07196)">
    <g
       id="g18994"
       transform="matrix(0.03021618,0,0,0.04467281,75.793039,127.80028)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:15.36313725;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 280.72353,286.04849 H 832"
         id="path3712"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:15.36313725;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 280.72353,409.57561 H 832"
         id="path3714"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:15.36313725;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 280.72353,533.10271 H 832"
         id="path3716"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:15.36313725;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 280.72353,656.62982 H 832"
         id="path3718"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:15.36313725;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 556.30509,162.77643 V 778.8725"
         id="path3728"
          />     
    </g>
  </g>
</svg>

`,
	12: html`
    <svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="28.237715mm"
   height="21.857071mm"
   viewBox="0 0 28.237715 21.857071"
   version="1.1"
   id="svg1348"
>
  <defs
     id="defs1342" />
  <g
     id="layer1"
     transform="translate(-74.327572,-220.30361)">
    <g
       id="g13915"
       transform="matrix(0.04418277,0,0,0.03323376,71.460616,216.19892)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:14.73007584;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 64.89184,287.08352 H 704"
         id="path3828"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:14.73007584;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 64.89184,452.39755 H 704"
         id="path3830"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:14.73007584;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 64.888544,617.71157 H 702.55077"
         id="path3832"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:14.73007584;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 504.1371,125.35898 V 781.18455"
         id="path3840"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:14.73007584;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 284.24267,123.50961 V 781.18633"
         id="path3842"
          />    
    </g>
  </g>
</svg>

`,
	15: html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="28.03285mm"
   height="28.036543mm"
   viewBox="0 0 28.03285 28.036543"
   version="1.1"
   id="svg1551"
>
  <defs
     id="defs1545" />
  <g
     id="layer1"
     transform="translate(-55.531192,-109.86863)">
    <g
       id="g15011"
       transform="matrix(0.04252029,0,0,0.0411317,52.72266,99.631318)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.49692059;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 66.05497,383.61014 H 725.3333"
         id="path3857"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.49692059;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 66.05497,520.05326 H 725.3333"
         id="path3859"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.49692059;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 66.051568,656.49638 H 723.83834"
         id="path3861"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.49692059;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 66.051568,792.93951 H 723.83834"
         id="path3863"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.49692059;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 519.16275,250.42118 V 930.51962"
         id="path3871"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:13.49692059;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 292.32848,248.89102 V 929.0949"
         id="path3873"
          />      
    </g>
  </g>
</svg>

`,
	18: html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="51.218163mm"
   height="40.100857mm"
   viewBox="0 0 51.218163 40.100857"
   version="1.1"
   id="svg1952"
>
  <defs
     id="defs1946" />
  <g
     id="layer1"
     transform="translate(-80.224247,-103.08052)">
    <g
       id="g22446"
       transform="matrix(0.07755054,0,0,0.0572226,71.819507,87.44977)">
      <g
         style="stroke:#e58b1f;stroke-width:4.21996069;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         transform="matrix(1.9337538,0,0,1.832376,-716.29646,-456.31365)"
         id="g3991">
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 426.9965,461.18633 H 767.67215"
           id="path3968"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 426.98932,525.18631 H 767.99998"
           id="path3970"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 426.99599,589.18633 H 767.67172"
           id="path3973"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 426.99623,653.18633 H 767.99997"
           id="path3975"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 426.46279,717.71966 H 767.67054"
           id="path3979"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 661.33333,398.81759 V 780.54812"
           id="path3983"
            />
        <path
           style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:4.50129128;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
           d="M 543.97587,398.10095 V 780.54703"
           id="path3985"
            />
      </g>   
    </g>
  </g>
</svg>

`,
	20: html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="51.12373mm"
   height="34.321445mm"
   viewBox="0 0 51.12373 34.321445"
   version="1.1"
   id="svg1791"
>
  <defs
     id="defs1785" />
  <g
     id="layer1"
     transform="translate(-71.955995,-121.84523)">
    <g
       id="g20117"
       transform="matrix(0.08275383,0,0,0.05374905,61.249607,109.54537)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 129.3766,355.04362 H 746.19267"
         id="path3891"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 129.37812,482.86356 H 747.15719"
         id="path3893"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 129.37787,610.68351 H 747.15715"
         id="path3895"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 129.37635,738.50346 H 746.19051"
         id="path3897"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 452.70825,230.27217 V 867.38853"
         id="path3905"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 290.72804,228.83871 V 866.05386"
         id="path3907"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.46333885;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 599.9327,230.27076 V 866.32338"
         id="path3909"
          />    
    </g>
  </g>
</svg>

`,
	21: html`
<svg
   
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
  
   width="51.289402mm"
   height="51.267696mm"
   viewBox="0 0 51.289402 51.267696"
   version="1.1"
   id="svg2113"
  >
  <defs
     id="defs2107" />
  
  
  <g
    
     id="layer1"
     transform="translate(-90.016014,-164.02091)">
    <g
       id="g23603"
       transform="matrix(0.07516908,0,0,0.06877431,83.517671,158.6397)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 87.922329,183.30106 H 768.11559"
         id="path4006"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 87.907996,290.033 H 768.77014"
         id="path4008"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 87.921307,396.76499 H 768.11475"
         id="path4010"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 87.921796,503.49696 H 768.77012"
         id="path4012"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.85673,611.11836 H 768.11238"
         id="path4016"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 555.79943,79.438467 V 822.65444"
         id="path4020"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 321.48343,78.24451 V 823.69287"
         id="path4022"
          />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:7.85034132;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.449678,717.85033 H 767.70533"
         id="path4026"
          />     
    </g>
  </g>
</svg>

`,
	25: html`
<svg
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   width="51.127861mm"
   height="39.053715mm"
   viewBox="0 0 51.127861 39.053715"
   version="1.1"
   id="svg2294">
  <defs
     id="defs2288" />
  <g
     id="layer1"
     transform="translate(-7.6979773,-22.71719)">
    <g
       id="g21293"
       transform="matrix(0.07738306,0,0,0.05730166,-3.943521,3.5123299)">
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 150.44101,470.32693 H 811.15115"
         id="path3928"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 150.44018,606.63613 H 810.36482"
         id="path3930"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 150.43997,742.94532 H 810.36483"
         id="path3932"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 150.43988,879.25452 H 810.36361"
         id="path3934"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="m 429.60404,337.2687 v 679.4309"
         id="path3942"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 289.67466,335.74004 V 1015.2763"
         id="path3944"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="M 556.78642,337.26721 V 1015.5637"
         id="path3946"
         />
      <path
         style="fill:none;fill-rule:evenodd;stroke:#e58b1f;stroke-width:8.47646236;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
         d="m 683.33289,335.15364 v 678.40746 0"
         id="path3948"
         />     
    </g>
  </g>
</svg>

`
};
